import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { TranslateService } from '@ngx-translate/core';
import { ViewService } from '../../../../Services/view.service';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { Macro } from 'app/Model/ui/Macro';

@Component({
    selector: 'userAction-deleteMediaByPurpose',
    templateUrl: 'userAction-deleteMediaByPurpose.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionDeleteMediaByPurpose) }
    ],
    standalone: false
})
export class UserActionDeleteMediaByPurpose extends UserActionBaseComponent {
  _allPurposes: string[];
  _selectedPurpose: string;

  txtSelectPurpose: string;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public systemService: SystemService
  ) {
    super(loginService, macroService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.txtSelectPurpose = this.translate.instant('Bitte wählen Sie eine Verwendung aus');

    this.allPurposes = ViewService.dropDownMimePurposes;
  }

  get allPurposes(): string[] {
    return this._allPurposes;
  }

  set allPurposes(value: string[]) {
    this._allPurposes = value;
  }

  get selectedPurpose(): string {
    return this._selectedPurpose;
  }

  set selectedPurpose(value: string) {
    this._selectedPurpose = value;
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.selectedPurpose == '' || this.selectedPurpose == undefined) {
      this.systemService.notifyInfo(this.txtSelectPurpose);
      return false;
    }

    return true;
  }

  public getActionId(macro: Macro): string {
    return `DeleteMediaByPurpose(${this.selectedPurpose})`;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({selectedPurpose: this.selectedPurpose});
  }
  public parseParameter(parameter: string) {
    throw new Error('Method not implemented.');
  }
}
